import { render, staticRenderFns } from "./pickupConfig.vue?vue&type=template&id=0dcbb24c&scoped=true&"
import script from "./pickupConfig.vue?vue&type=script&lang=js&"
export * from "./pickupConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcbb24c",
  null
  
)

export default component.exports